<template>
  <div class="widget" style="z-index: 1">
    <div  v-if="isMeetingOpen && accountUser.admin == true" ref="meeting-notes-sidebar-wrap">
      <b-button 
        v-b-toggle.meeting-notes-sidebar
        size="lg"
        variant="primary"
        pill
        class="btn-fixed-toggle">
        <b-icon
          icon="pencil-square"
          aria-label="Toggle Meeting Notes Sidebar"
          title="Toggle Meeting Notes Sidebar"
          >Toggle Meeting Notes Sidebar</b-icon
        >
      </b-button>
      <b-sidebar 
        ref="meetingNotesSidebar" 
        id="meeting-notes-sidebar" 
        class="notes-sidebar" 
        shadow 
        right
        no-header
      >
        <template #default="{ hide }">
            <div class="px-3 pb-3">
            <b-row>
              <b-col cols="12" class="widget-label">
                <p>Notes</p>
                <!-- <button @click="hide" type="button" aria-label="Close" class="close">×</button> -->
                <button @click="hide" type="button" aria-label="Close" class="close">
                  <b-icon icon="chevron-right" scale=".8"></b-icon>
                </button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="mb-2 custom-search dark position-relative">
                  <b-form @submit.prevent="onAddCommentSubmit">
                    <b-form-group label="Add a note" label-for="meeting-comment">
                      <b-form-textarea
                        id="meeting-comment"
                        v-model.trim="form.comment"
                        maxlength="500"
                        @input.native="mixin_resizeTextarea"
                      ></b-form-textarea>
                    </b-form-group>
                    <b-button
                      type="submit"
                      :disabled="sending || form.comment.length === 0"
                    >
                      <b-spinner v-if="sending" small label="Spinning" />
                      <div v-else>Add</div>
                    </b-button>
                  </b-form>
                </div>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-sidebar>
    </div>
    <div class="widget-label">
      <div class="label">
        <p>General Notes</p>
      </div>
    </div>
    <div class="widget-content">
      <!-- Underneathe is where the Meeting Comments will show -->
      <b-row v-if="meetingComments.length > 0">
        <b-col
          cols="12"
          v-for="comment in meetingComments"
          v-bind:key="comment.commentId"
        >
          <b-overlay
            :show="comment.sending"
            variant="light"
            opacity="0.85"
            blur="2x"
            rounded="sm"
          >
            <div v-if="!comment.deleted">
              <b-form
                class="meeting-comment"
                @submit.prevent="onEditCommentSubmit(comment.commentId)"
              >
                <b-row class="mb-2">
                  <b-col>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <span class="comment-name pr-2">{{ comment.createdBy.name }}</span>
                      <span class="float-right comment-date">{{
                        dateFormat(comment.date)
                      }}</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col cols="8" v-if="comment.editing">
                    <b-form-group for="edit-comment">
                      <b-form-textarea
                        id="edit-comment"
                        v-model.trim="comment.newContent"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col cols="8" v-else>
                    <p class="pre-wrap break-word">{{ comment.content }}</p>
                  </b-col>
                  <b-col cols="4" class="d-flex justify-content-end">
                    <b-button
                      variant="tertiary"
                      v-if="
                        comment.createdBy.id === accountUser.userId &&
                        !comment.editing &&
                        accountUser.admin == true
                      "
                      :disabled="editingCommentId !== ''"
                      @click="startEditing(comment.commentId)"
                    >
                      <b-icon
                        icon="pencil-square"
                        aria-label="Edit"
                        title="Edit"
                        >Edit</b-icon
                      >
                    </b-button>
                    <b-button
                      variant="tertiary"
                      v-if="
                        comment.createdBy.id === accountUser.userId &&
                        !comment.editing &&
                        accountUser.admin == true
                      "
                      @click="showDeleteConfirmation(comment)"
                      :disabled="deletingCommentId !== ''"
                    >
                      <b-icon
                        icon="trash-fill"
                        aria-label="Delete"
                        title="Delete"
                        >Delete</b-icon
                      >
                    </b-button>
                    <b-button
                      variant="tertiary"
                      v-if="comment.editing"
                      @click="cancelEditing(comment.commentId)"
                    >
                      <b-icon icon="x" aria-label="Cancel" title="Cancel"
                        >Cancel</b-icon
                      >
                    </b-button>
                    <b-button
                      variant="tertiary"
                      v-if="comment.editing"
                      @click="onEditCommentSubmit(comment.commentId)"
                    >
                      <b-icon icon="check2" aria-label="Save" title="Save"
                        >Save</b-icon
                      >
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </b-overlay>
        </b-col>
      </b-row>
      <b-col cols="12">
        <div class="no-card">
          <b-card-text
          v-if="meetingComments.length == 0"
          style="margin: 20px; text-align: center">
            <p>
              {{
                isMeetingOpen
                  ? (emptyText = "No notes yet.")
                  : (emptyText = "No notes for this meeting")
              }}
            </p>
          </b-card-text>
        </div>
      </b-col>
      <!-- <div class="position-absolute w-100 custom-search__modal widget"> -->
      <b-modal
        v-model="showModal"
        v-if="meetingComments"
        ok-only
        ok-title="Close"
        size="lg"
        @ok.prevent="cancel"
      >
      </b-modal>
      <BaseConfirmationModal
        ref="del-comment-confirmation"
        title="Are you sure you want to delete this note?"
        :message="deleteConfirmText"
        okText="Yes"
        cancelText="No"
        @submit="onDeleteCommentConfirm"
        @cancel="cancelDelete"
      ></BaseConfirmationModal>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import MeetingCommentsList from "@/components/meeting/MeetingCommentsList.vue";
import BaseConfirmationModal from "@/components/BaseConfirmationModal.vue";
import pmMixin from "@/mixins/project-metric-mixin.js";
import { utc } from "moment";
import textareaResizeMixin from "@/mixins/textarea-resize-mixin.js";

export default {
  components: {
    MeetingCommentsList,
    BaseConfirmationModal,
  },
  mixins: [
    pmMixin, 
    textareaResizeMixin
  ],
  props: {
    projectId: {
      type: String,
      default: "",
    },
    isMeetingOpen: {
      type: Boolean,
      required: true
    },
    meetingId: {
      type: String,
      default: "",
    },
    meetingComments: { type: Array, default: () => [] },
  },
  data() {
    return {
      errors: [],
      form: this.newForm(),
      deletingCommentId: "",
      deletingCommentContent: "",
      editingCommentId: "",
      sending: false,
      showModal: false,
      allUsersName: [],
      starFill: "star-fill",
      starEmpty: "star",
      testArray: [],
      emptyText: "No Comments To Show!",
      user: "",
      allCommentsUI: this.meetingComments,
    };
  },
  methods: {
    show() {
      return (this.showModal = true);
    },
    hide() {
      return (this.showModal = false);
    },
    cancel() {
      this.reset();
      this.hide();
    },
    reset() {
      this.form = this.newForm();
      this.deletingCommentId = "";
      this.editingCommentId = "";
      this.sending = false;
    },
    onAddCommentSubmit() {
      if (this.form.comment.length === 0) {
        return;
      }
      var guidCommentId = this.$helpers.generateUUID();
      let request = {
        commentId: guidCommentId,
        date: new Date(),
        content: this.form.comment,
        userId: this.accountUser.userId
      };
      let allCommentsUI = { 
        meetingId: this.meetingId, 
        commentId: guidCommentId, 
        date: request.date, 
        lastEdited: null, 
        content: this.form.comment, 
        createdBy: { 
          name: this.accountUser.name, 
          id: this.accountUser.userId, 
          icon: null 
        }, 
        dateCreated: null 
      }
      this.sending = true;
      axios
        .post(
          `${this.$api_url}/meeting/${this.meetingId}/notes/add`,
          request,
          this.getReqConfig()
        )
        .then(() => {
          this.form = this.newForm();
          this.$emit("refresh", this.meetingId);
          this.closeNoteSidebar();
        })
        .catch(() => {
          //Do something about it
        })
        .finally(() => {
          this.sending = false;
          this.$emit("refresh", this.meetingId);
        });
      this.meetingComments.unshift(allCommentsUI);
      this.form.comment = "";
      this.sending = false;
      this.meetingComments = this.meetingComments.sort((a, b) =>
        a.dateCreated > b.dateCreated ? -1 : 1
      );
    },
    newForm() {
      return {
        commentId: null,
        meetingId: null,
        dateCreated: null,
        comment: "",
        favorited: false,
        commentHidden: false,
        deleted: false,
        userId: null,
        editing: false,
        sending: false,
        newContent: "",
      };
    },
    dateFormat(date) {
      if (date != null) {
        this.commentDate = new Date(date);
        let line =
          this.commentDate.toLocaleString("default", {
            hour: "2-digit",
            minute: "2-digit",
          }) +
          ", " +
          this.commentDate.toLocaleString("default", {
            month: "long",
            day: "numeric",
            year: "numeric",
          });
        return line;
      }
      return;
    },
    startEditing(id) {
      const comment = this.meetingComments.find((c) => c.commentId === id);
      this.editingCommentId = id;
      comment.editing = true;
      comment.newContent =
        comment.content;
    },
    cancelEditing(id) {
      const comment = this.meetingComments.find((c) => c.commentId === id);
      this.editingCommentId = "";
      comment.editing = false;
      comment.newContent =
        comment.content;
      this.meetingComments = this.meetingComments.sort((a, b) =>
          a.dateCreated > b.dateCreated ? -1 : 1
        );
    },
    showDeleteConfirmation(comment) {
      this.deletingCommentId = comment.commentId;
      this.deletingCommentContent = comment.content;
      this.$refs["del-comment-confirmation"].show();
    },
    cancelDelete() {
      this.deletingCommentId = "";
      this.deletingCommentContent = "";
    },
    onDeleteCommentConfirm() {
      const comment = this.meetingComments.find(
        (c) => c.commentId === this.deletingCommentId
      ),
            commentIndex = this.meetingComments.findIndex(
        (c) => c.commentId === this.deletingCommentId
      );
      comment.sending = true;
      
      axios
        .delete(
          `${this.$api_url}/meeting/${this.meetingId}/note/${this.deletingCommentId}/delete`,
          this.getReqConfig()
        )
        .then(() => {
          this.$emit("refresh", this.meetingId);
        })
        .catch(() => {
          this.meetingComments.find(
            (c) => c.commentId === this.deletingCommentId
          ).sending = false;
        })
        .finally(() => {
          this.deletingCommentId = "";
          this.deletingCommentContent = "";
          comment.deleted = true;
          comment.sending = false;
          this.meetingComments.splice(commentIndex,1);
        });
          
    },
    onEditCommentSubmit(id) {
      let comment = this.meetingComments.find((c) => c.commentId === id);

      if (comment.newContent === "") {
        return;
      }
      let request = {
        CommentId: comment.commentId,
        Comment: comment.newContent,
        DateEdited: new Date(),
        CommentHidden: comment.commentHidden,
        Favorited: comment.favorited,
        UserId: comment.createdBy.id,
        Deleted: comment.deleted
      };

      comment.sending = true;
      comment.content = comment.newContent;
      comment.editing = true;
      axios
        .post(
          `${this.$api_url}/meeting/${this.meetingId}/notes/${comment.commentId}/update`,
          request,
          this.getReqConfig()
        )
        .then(() => {
          comment.editing = false;
          comment.sending = false;
          this.editingCommentId = "";
          this.meetingComments = this.meetingComments.sort((a, b) =>
            a.dateCreated > b.dateCreated ? -1 : 1
          );
          this.$emit("refresh", this.meetingId);
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    moveNotesSidebarToBody() {
      document.querySelector('.page-container').appendChild(this.$refs['meeting-notes-sidebar-wrap']);
    },
    closeNoteSidebar() {
      this.$refs.meetingNotesSidebar.hide();
    }
  },
  mounted(){
    if (this.isMeetingOpen) {
      this.moveNotesSidebarToBody();
    }
  },
  computed: {
    deleteConfirmText() {
      return `"${this.deletingCommentContent}"`;
    }
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.custom-search {
  &__modal {
    background: white;
    border-radius: 4px;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    transition: all 0.15s ease-in-out;

    &.open {
      top: 42px;
      opacity: 1;
      height: auto;
      z-index: 2;
    }
  }
  &__result {
    position: absolute;
    height: 100%;
    left: 48px;
    top: 0px;
    display: flex;
    align-items: center;
    pointer-events: none;
    font-size: var(--body-p);
    opacity: 0.2;
    &--left-over {
      background: #90a0b7;
    }
  }
}
</style>